import { BillingExpenseRevenueFormValues } from '@/core/domain/workorder/ManagementCharts/ManagementChart.types';
import { Form, Modal, ModalProps } from 'antd';
import React from 'react';
import InvoicingBillingXPaymentsXReceiptsForm from './InvoicingBillingXPaymentsXReceiptsForm';

type Props = Omit<ModalProps, 'onOk'> & {
  handleOk: (values: BillingExpenseRevenueFormValues) => void;
};

const InvoicingBillingXPaymentsXReceiptsModal: React.FC<Props> = ({
  open,
  onCancel,
  handleOk,
}) => {
  const [form] = Form.useForm<BillingExpenseRevenueFormValues>();
  const formValues = Form.useWatch([], form);

  return (
    <Modal
      title="Faturamento x Pagamentos x Recebimentos"
      open={open}
      onCancel={onCancel}
      width={600}
      okText="Atualizar Gráfico"
      onOk={() => handleOk(formValues)}
    >
      <InvoicingBillingXPaymentsXReceiptsForm form={form} />
    </Modal>
  );
};

export default InvoicingBillingXPaymentsXReceiptsModal;
